import React from "react";
import { View, TextInput, StyleSheet, TouchableOpacity } from "react-native";
import { typography, spacing } from "../../theme";
import { useColors, ThemeColors } from "../../hooks/useColors";
import { Feather } from "@expo/vector-icons";

export interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  placeholder?: string;
}

export function SearchBar({
  searchQuery,
  setSearchQuery,
  placeholder = "Search...",
}: SearchBarProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  const [inputValue, setInputValue] = React.useState(searchQuery);

  // Update local value when prop changes
  React.useEffect(() => {
    setInputValue(searchQuery);
  }, [searchQuery]);

  const handleSubmit = () => {
    setSearchQuery(inputValue);
  };

  const handleClear = () => {
    setInputValue("");
    setSearchQuery("");
  };

  return (
    <View style={styles.container}>
      <Feather name="search" size={20} color={colors.textLight} />
      <TextInput
        style={styles.input}
        placeholder={placeholder}
        placeholderTextColor={colors.textLight}
        value={inputValue}
        onChangeText={setInputValue}
        onSubmitEditing={handleSubmit}
        returnKeyType="search"
      />
      {!!inputValue && (
        <TouchableOpacity onPress={handleClear}>
          <Feather name="x" size={20} color={colors.textLight} />
        </TouchableOpacity>
      )}
    </View>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.surface,
    borderRadius: 24,
    paddingHorizontal: spacing.md,
    paddingVertical: 12,
    marginHorizontal: spacing.lg,
    marginTop: spacing.sm,
    shadowColor: colors.shadow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  input: {
    flex: 1,
    fontSize: 16,
    marginHorizontal: spacing.sm,
    color: colors.text,
  },
});
